import React from 'react';
import Text from './base';

const SmallUppercase = props => <Text tag="h5" variant="h5" {...props} />;

export default SmallUppercase;
